import { useState, useEffect, useCallback, Fragment } from "react";
import { Table, Card, CardHeader, CardTitle, Media } from "reactstrap";
import Select from "react-select";
import { H5, H4, Btn } from "../../../../AbstractElements";
import {
  ListSalary,
  StoreDoctorSalary,
  StoreStaffSalary,
  UpdateConsultantPayment,
  DeleteSalary,
  DoctorList,
  StaffList,
  UpdateSalary
} from "../../../../apiController";
import {
  Button,
  Modal,
  ModalHeader,
  CardBody,
  CardFooter,
  FormGroup,
  Label,
  Input,
  ModalBody,
  Form,
  Row,
  Col,
  NavItem,
  Nav,
  NavLink,
} from "reactstrap";
import DataTable from "react-data-table-component";
import SweetAlert from "sweetalert2";
import { toast } from "react-toastify";
import { useForm, Controller } from "react-hook-form";
import CloseModal from "../../../../Constant/CloseModal";

//ConsultantExpense

const Salary = ({permission}) => {

  console.warn(permission)
  const [expense, setExpense] = useState([]);
  const [selectedMonthID, setSelectedMonthID] = useState(null);
  const [options, setOptions] = useState([]);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [selectedRows, setSelectedRows] = useState([]);
  const [toggleDelet, setToggleDelet] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [Large, setLarge] = useState(false);
  const [modal, setModal] = useState(false);
  const [details, setDetails] = useState([]);
  const [edit, setEdit] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [filePreview, setFilePreview] = useState("");

  const [activeTab, setActiveTab] = useState("staff");

  const [doctor, setDoctor] = useState([]);
  const [staff, setStaff] = useState([]);

  const toggleModal = () => {
    setLarge(!Large);
  };
  const toggleDoc = (doc) => {
    console.log(doc);
    setModal(!modal);
    setDetails(doc);
  };

  const toggle = (monthID) => {
    setSelectedMonthID(monthID);
    setSelectedRows([]);
    setShowDetails(!showDetails);
  };

  const handleRowSelected = useCallback((state) => {
    console.log(state)
    setSelectedRows(state.selectedRows);
  }, []);

  const handleDelete = async () => {
    const result = await SweetAlert.fire({
      title: "Are you sure you want to delete?",
      cancelButtonText: "No!",
      confirmButtonText: "Yes!",
      reverseButtons: true,
      showCancelButton: true,
    });

    if (result.isConfirmed) {
      console.log(selectedRows)
      try {
        const selectedIds = selectedRows.map((row) => row.id);
        const selectedType = selectedRows[0].type;
        await Promise.all(
          selectedIds.map((id) => DeleteSalary(id, selectedType))
        );
        setSelectedRows([]);
        toast.success("Deleted Successfully!", {
          position: toast.POSITION.TOP_CENTER,
        });
        fetchotherExpense();
      } catch (error) {
        toast.error("An error occurred!", {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    }
  };

  const type = expense
    .filter((row) => row.month === selectedMonthID && row.year === selectedYear)
    .flatMap((row) =>
      row.salary_list.map((doc, ind) => {
        console.log(row);
        return {
          ind: ind + 1,
          id:
            doc.staff_salary_id !== null
              ? doc.staff_salary_id
              : doc.doctor_salary_id,
          emplaoyeeid: (
            <p body className="align-self-center f-w-700 font-success">
              {" "}
              {doc.staff_salary_id !== null ? doc.staff_id : doc.doctor_id}
            </p>
          ),
          employeename: doc.staff_name,
          category:
            doc.staff_category_name !== null
              ? doc.staff_category_name
              : doc.doctor_department_name,
          netsalary: doc.salary,
          allowance: doc.allowance,
          tax: doc.income_tax,
          otc: doc.otc,
          epf: doc.epf,
          salary: doc.gross_salary,
          type: doc.type,
          action: (
            <span key={ind} className="d-flex gap-3">
              <Btn
                attrBtn={{
                  style: { width: 60, fontSize: 14, padding: 4 },
                  color: "secondary",
                  className: "btn btn-xs",
                  type: "button",
                  onClick: () => handleEdit(doc),
                }}
              >
                Edit
              </Btn>
            </span>
          ),
        };
      })
    );

  const monthDataColumns = [
    { name: "#", selector: (row) => row.ind, sortable: true },
    {
      name: "Employee ID",
      selector: (row) => row.emplaoyeeid,
      sortable: true,
      center: true,
    },
    {
      name: "Employee Name",
      selector: (row) => row.employeename,
      sortable: true,
      center: true,
    },
    {
      name: "Employee Category",
      selector: (row) => row.category,
      sortable: true,
      center: true,
    },
    {
      name: "Net Salary",
      selector: (row) => row.netsalary,
      sortable: true,
      center: true,
    },
    {
      name: "Allowance",
      selector: (row) => row.allowance,
      center: true,
      sortable: true,
    },
    {
      name: "Tax",
      selector: (row) => row.tax,
      center: true,
      sortable: true,
    },
    {
      name: "OTC",
      selector: (row) => row.otc,
      center: true,
      sortable: true,
    },
    {
      name: "EPF",
      selector: (row) => row.epf,
      center: true,
      sortable: true,
    },
    {
      name: "Gross Salary",
      selector: (row) => row.salary,
      center: true,
      sortable: true,
    },
    // {
    //   name: "Action",
    //   selector: (row) => row.action,
    //   center: true,
    // },
  ];
  if(permission?.edit_access){
    monthDataColumns.push(
      {
        name: "Edit",
        selector: (row) => row.action,
        center: true,
      },
    )
  }

  const tableHeader = ["#", "Month", "Total"];
  const months = [
    { id: 1, month: "January" },
    { id: 2, month: "February" },
    { id: 3, month: "March" },
    { id: 4, month: "April" },
    { id: 5, month: "May" },
    { id: 6, month: "June" },
    { id: 7, month: "July" },
    { id: 8, month: "August" },
    { id: 9, month: "September" },
    { id: 10, month: "October" },
    { id: 11, month: "November" },
    { id: 12, month: "December" },
  ];

  useEffect(() => {
    fetchotherExpense();
  }, []);

  const fetchotherExpense = async () => {
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth() + 1;
    const response = await ListSalary({ month: currentMonth });
    if (response.status === true) {
      setExpense(response.data.reverse());
      const uniqueYears = [...new Set(response.data.map((item) => item.year))];
      const yearOptions = uniqueYears.map((year) => ({
        value: year,
        label: year,
      }));
      setOptions(yearOptions);
    }
  };

  const handleEdit = (row) => {
    console.log("Edit row:", row);
    setEdit(!edit);

    if(row.staff_id !== null){
      setActiveTab("staff")
    }else{
      setActiveTab("doctor")
    }
  
    setLarge(!Large);
    setValue("staff_id", row.staff_id !== null? row.staff_id : row.doctor_id);
    setValue("salary", row.salary);
    setValue("otc", row.otc);
    setValue("epf", row.epf);
    setValue("income_tax", row.income_tax);
    setValue("id", row.staff_salary_id !== null?row.staff_salary_id : row.doctor_salary_id );
    setValue("allowance", row.allowance);
    setValue("employee_id", row.staff_id !== null? row.staff_id : row.doctor_id);
    setValue("employee_type", row.type);
  };

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    control,
    reset,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    console.log(data);
    const formData =  {
        staff_id: activeTab === "staff" ? data.staff_id : null,
        doctor_id:activeTab === "doctor" ? data.staff_id :  null,
        salary: data.salary,
        allowance: data.allowance,
        income_tax: data.income_tax,
        otc: data.otc,
        epf: data.epf,
        id: data.id,
        employee_type: data.employee_type,
        employee_id: data.employee_id

    }
    
    if (edit) {
      console.log(formData);
      updateSalaryExpenses(formData)
  } else{
      if (activeTab === "staff" && !edit) {
          console.log(formData);
          storeStaffExpenses(formData);
      } else if (activeTab === "doctor" && !edit) {
          console.log(formData);
          storeDoctorExpenses(formData);
      }
  }
  

    // if (activeTab === "staff") {
    //   console.log(formData);
    //   storeStaffExpenses(formData)
    // } else if(activeTab === "doctor") {
    //   console.log(formData);
    //   storeDoctorExpenses(formData)
    // } else if (edit)
    // {
    //   console.log(formData);
    // }
  };

  const storeDoctorExpenses = async (formData) => {
    setIsSubmitting(true);
    try {
      const response = await StoreDoctorSalary(formData);
      if (response.status === true) {
        toast.success("Created Successfully!", {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      toast.error("An error occurred!", {
        position: toast.POSITION.TOP_CENTER,
      });
    } finally {
      fetchotherExpense();
      reset();
      setFilePreview("");
      setLarge(!Large);
      setIsSubmitting(false);
    }
  };
  const storeStaffExpenses = async (formData) => {
    setIsSubmitting(true);
    try {
      const response = await StoreStaffSalary(formData);
      if (response.status === true) {
        toast.success("Created Successfully!", {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      toast.error("An error occurred!", {
        position: toast.POSITION.TOP_CENTER,
      });
    } finally {
      fetchotherExpense();
      reset();
      setFilePreview("");
      setLarge(!Large);
      setIsSubmitting(false);
    }
  };

  const updateSalaryExpenses = async (formData) => {
    setIsSubmitting(true);
    try {
      const response = await UpdateSalary(formData);
      if (response.status === true) {
        toast.success("Updated Successfully!", {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      toast.error("An error occurred!", {
        position: toast.POSITION.TOP_CENTER,
      });
    } finally {
      fetchotherExpense();
      reset();
      setEdit(!edit)
      setFilePreview("");
      setLarge(!Large);
      setIsSubmitting(false);
    }
  };

  const fetchDoctor = async () => {
    const response = await DoctorList();
    if (response.status === true) {
      setDoctor(response.data);
    }
  };

  const fetchStaff = async () => {
    const response = await StaffList();
    if (response.status === true) {
      setStaff(response.data);
    }
  };

  useEffect(() => {
    fetchStaff();
    fetchDoctor();
  }, []);

  console.log(expense);

  const option = activeTab === "staff" ? staff : doctor;

  return (
    <>
      {!showDetails && (
        <Card>
          <CardHeader className="d-flex gap-4 justify-content-evenly align-items-center">
            <CardTitle>Select Year</CardTitle>
            <Select
              options={options}
              className="js-example-basic-single col-sm-3"
              value={options.find((option) => option.value === selectedYear)}
              onChange={(option) => setSelectedYear(option.value)}
            />
            <H5 className="align-self-end">Salary</H5>
            {permission?.create_access && <button
              type="button"
              className="btn btn-primary"
              aria-hidden="true"
              onClick={toggleModal}
              style={{ cursor: "pointer", backgroundColor: "#145BD9" }}
            >
              <span className="me-1">+</span>
              Add Salary
            </button>}
          </CardHeader>
          <Table responsive striped>
            <thead>
              <tr className="text-center">
                {tableHeader.map((heads, i) => (
                  <th key={i}>{heads}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {months.map((data) => (
                <tr className="text-center" key={data.id}>
                  <td>{data.id}</td>
                  <td>
                    <Media body className="align-self-center f-w-700 font-info">
                      <span
                        onClick={() => toggle(data.id)}
                        style={{ cursor: "pointer" }}
                      >
                        {data.month}
                      </span>
                    </Media>
                  </td>
                  <td>
                    {expense
                      .filter(
                        (main) =>
                          main.month === data.id && main.year === selectedYear
                      )
                      .map((main, index) => (
                        <span key={index}>
                          {main.salary_sum ? main.salary_sum : "N/A"}
                        </span>
                      ))}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Card>
      )}
      {showDetails && !modal && (
        <Card>
          <CardHeader
            toggle={() => toggle(null)}
            className=" bg-light"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
          >
            <span className=" bg-light ">
              Details for{" "}
              {months.find((m) => m.id === selectedMonthID)?.month || "N/A"}
            </span>
          </CardHeader>
          <CardBody>
            <Fragment>
              {selectedRows.length !== 0 && (
                <div className="d-flex align-items-center justify-content-between bg-light-info p-2">
                  <H4 attrH4={{ className: "text-muted m-0" }}>
                    Delete Selected Data..!
                  </H4>
                  <Btn
                    attrBtn={{ color: "danger", onClick: () => handleDelete() }}
                  >
                    Delete
                  </Btn>
                </div>
              )}
              <DataTable
                data={type}
                columns={monthDataColumns}
                striped={true}
                center={true}
                pagination
                selectableRows = {permission?.delete_access}
                onSelectedRowsChange={handleRowSelected}
                clearSelectedRows={toggleDelet}
              />
            </Fragment>
          </CardBody>
          <CardFooter>
            <Button color="secondary" onClick={() => toggle(null)}>
              Back
            </Button>
          </CardFooter>
        </Card>
      )}

      <Modal isOpen={Large} toggle={toggleModal} centered>
        <ModalHeader className="text-white bg-dark p-2 justify-content-center">
          Salary Expenses
        </ModalHeader>
        <ModalHeader>
          <Nav justified pills>
            <NavItem>
              <NavLink
                active={activeTab === "staff"}
                onClick={() => setActiveTab("staff")}
              >
                Staff
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                active={activeTab === "doctor"}
                onClick={() => setActiveTab("doctor")}
              >
                Doctor
              </NavLink>
            </NavItem>
          </Nav>
        </ModalHeader>
        <ModalBody>
          <Card>
            <CardBody>
              {/* <Form onSubmit={handleSubmit(onSubmit)} style={{ paddingLeft: "50px", paddingRight: "50px", marginTop: '-10px' }}>
            <FormGroup className="mb-4">
                <Label for="staff_id" className="required">Employee Id:</Label>
                <Input 
                    type="select" 
                    id="staff_id" 
                    {...register('staff_id', { required: "Employee Id is required" })} // Register the select with staff_id
                >
                    <option value="">Select Employee Id</option>
                    {option.map((employee) => (
                            <option key={employee.employee_number} value={employee.employee_number}>
                                {`${employee.first_name} ${employee.surname}`}
                            </option>
                        ))}
                </Input>
                {errors.staff_id && <p className="text-danger">{errors.staff_id.message}</p>}
            </FormGroup>

            <FormGroup className="mb-4">
                <Label for="salary" className="required">Basic Salary:</Label>
                <Input 
                    id="salary"
                    {...register('salary', { 
                        required: "Salary is required", 
                        pattern: {
                            value: /^[0-9]*$/,
                            message: "Only numbers are allowed"
                        }
                    })} 
                    type="text" 
                    placeholder="Salary"
                />
                {errors.salary && <p className="text-danger">{errors.salary.message}</p>}
            </FormGroup>

            <FormGroup className="mb-4">
                <Label for="allowance" className="required">Allowance:</Label>
                <Input 
                    id="allowance"
                    {...register('allowance', { 
                        required: "Allowance is required", 
                        pattern: {
                            value: /^[0-9]*$/,
                            message: "Only numbers are allowed"
                        }
                    })} 
                    type="text" 
                    placeholder="Allowance"
                />
                {errors.allowance && <p className="text-danger">{errors.allowance.message}</p>}
            </FormGroup>

            <FormGroup className="mb-4">
                <Label for="otc" className="required">OTC:</Label>
                <Input 
                    id="otc"
                    {...register('otc', { 
                        required: "OTC is required", 
                        pattern: {
                            value: /^[0-9]*$/,
                            message: "Only numbers are allowed"
                        }
                    })} 
                    type="text" 
                    placeholder="OTC"
                />
                {errors.otc && <p className="text-danger">{errors.otc.message}</p>}
            </FormGroup>

            <FormGroup className="mb-4">
                <Label for="income_tax" className="required">Income Tax:</Label>
                <Input 
                    id="income_tax"
                    {...register('income_tax', { 
                        required: "Income tax is required", 
                        pattern: {
                            value: /^[0-9]*$/,
                            message: "Only numbers are allowed"
                        }
                    })} 
                    type="text" 
                    placeholder="Income Tax"
                />
                {errors.income_tax && <p className="text-danger">{errors.income_tax.message}</p>}
            </FormGroup>

            <FormGroup className="mb-4">
                <Label for="epf" className="required">EPF:</Label>
                <Input 
                    id="epf"
                    {...register('epf', { 
                        required: "EPF is required", 
                        pattern: {
                            value: /^[0-9]*$/,
                            message: "Only numbers are allowed"
                        }
                    })} 
                    type="text" 
                    placeholder="EPF"
                />
                {errors.epf && <p className="text-danger">{errors.epf.message}</p>}
            </FormGroup>

            <Button type="submit" color="primary" disabled={isSubmitting}>
            {isSubmitting ? "Submitting..." : "Submit"}
            </Button>
            <Button type="button" color="secondary"  onClick={toggleModal} >
            Cancel
            </Button>
        </Form> */}
              <Form
                onSubmit={handleSubmit(onSubmit)}
                style={{
                  paddingLeft: "50px",
                  paddingRight: "50px",
                  marginTop: "-10px",
                }}
              >
                <Row>
                  <Col></Col>
                  <Col></Col>
                </Row>
                <FormGroup className="mb-4">
                  <Label for="staff_id" className="required">
                    Employee Id:
                  </Label>
                  <Controller
                    name="staff_id"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <Input type="select" id="staff_id" {...field}>
                        <option value="">Select Employee Id</option>
                        {option.map((employee) => (
                          <option
                            key={employee.employee_number}
                            value={employee.employee_number}
                          >
                            {`${employee.first_name} ${employee.surname}`}
                          </option>
                        ))}
                      </Input>
                    )}
                  />
                  {errors.staff_id && (
                    <p className="text-danger">{errors.staff_id.message}</p>
                  )}
                </FormGroup>

                {["salary", "allowance", "otc", "income_tax", "epf"].map(
                  (fieldName) => (
                    <FormGroup className="mb-4" key={fieldName}>
                      <Label for={fieldName} className="required">
                        {fieldName.replace("_", " ").toUpperCase()}:
                      </Label>
                      <Controller
                        name={fieldName}
                        control={control}
                        defaultValue=""
                        rules={{
                          required: `${
                            fieldName.charAt(0).toUpperCase() +
                            fieldName.slice(1)
                          } is required`,
                          pattern: {
                            value: /^[0-9]+(\.[0-9]{1,2})?$/,
                            message: "Only numbers are allowed",
                          },
                        }}
                        render={({ field }) => (
                          <Input
                            id={fieldName}
                            type="number"
                            step="0.01"
                            placeholder={
                              fieldName.charAt(0).toUpperCase() +
                              fieldName.slice(1)
                            }
                            {...field}
                          />
                        )}
                      />
                      {errors[fieldName] && (
                        <p className="text-danger">
                          {errors[fieldName].message}
                        </p>
                      )}
                    </FormGroup>
                  )
                )}

                <Button type="submit" color="primary" disabled={isSubmitting}>
                  {isSubmitting ? "Submitting..." : "Submit"}
                </Button>
                <Button type="button" color="secondary" onClick={toggleModal}>
                  Cancel
                </Button>
              </Form>
              {/* <Form
                className="form theme-form"
                onSubmit={handleSubmit(onSubmit)}
              >
                <div className="row">
                  <div className="col-md-6 mb-sm-7 mb-4">
                    <label className="form-label">
                      <span className="required">Salary</span>
                    </label>
                    <Controller
                      name="paid_amt"
                      control={control}
                      rules={{ required: true }}
                      render={({ field }) => (
                        <Input
                          type="number"
                          placeholder="Payment"
                          {...field}
                          className={`form-control ${
                            errors.paid_amt ? "is-invalid" : ""
                          }`}
                          onChange={(e) => {
                            const value = e.target.value;
                            field.onChange(value);
                          }}
                          required
                        />
                      )}
                    />
                    <span className="text-danger">
                      {errors.paid_amt && "Payment is required"}
                    </span>
                  </div>

                  <div className="col-md-6 mb-sm-7 mb-4">
                    <label className="form-label">
                      <span className="required">Status</span>
                    </label>
                    <Controller
                      name="status"
                      control={control}
                      rules={{ required: true }}
                      render={({ field }) => (
                        <Input
                          type="text"
                          placeholder="Status"
                          {...field}
                          className={`form-control ${
                            errors.status ? "is-invalid" : ""
                          }`}
                          onChange={(e) => {
                            const value = e.target.value;
                            field.onChange(value);
                          }}
                          required
                        />
                      )}
                    />
                    <span className="text-danger">
                      {errors.status && "Status is required"}
                    </span>
                  </div>
                </div>
                <div className="d-flex justify-content-between">
                  <button
                    type="submit"
                    className="btn btn-primary"
                    style={{ width: "150px", margin: "auto", display: "block" }}
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Submitting..." : "Submit"}
                  </button>
                  <button
                    className="btn btn-secondary"
                    style={{ width: "150px", margin: "auto", display: "block" }}
                    onClick={toggleModal}
                  >
                    {"Cancel"}
                  </button>
                </div>
              </Form> */}
            </CardBody>
          </Card>
        </ModalBody>
      </Modal>
    </>
  );
};

export default Salary;
